import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

export default function PermissionRoute({ module, action = 'view', adminOnly = false, children }) {
  const { user, loading, hasPermission, canAccessModule } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('checking'); // checking | ok | denied

  useEffect(() => {
    if (loading) return;

    // Not authenticated
    if (!user) {
      setStatus('denied');
      navigate('/admin/login');
      return;
    }

    // Bypass from OAuth callback
    if (location.state?.user) {
      setStatus('ok');
      return;
    }

    // Admin-only check
    if (adminOnly && user.role !== 'ADMIN') {
      toast.error('Accès réservé aux administrateurs');
      setStatus('denied');
      navigate('/admin');
      return;
    }

    // Module permission check
    if (module && !canAccessModule(module, action)) {
      toast.error('Vous n\'avez pas la permission d\'accéder à cette page');
      setStatus('denied');
      navigate('/admin');
      return;
    }

    setStatus('ok');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading, module, action, adminOnly, navigate, location.state, canAccessModule]);

  if (loading || status === 'checking') {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-garden-800 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status === 'denied') return null;
  return children;
}
